import Table from '@risksmart-app/components/src/table';
import ExportButton from 'src/components/export-button';
import TabHeader from 'src/components/tab-header';
import type { useGetAttestationsRegister } from 'src/hooks/queries/attestations/useGetAttestationsRegister';
import { PageLayout } from 'src/layouts';
import { getCounter } from 'src/utils';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';

import { AttestationRegisterToolbar } from '../AttestationRegisterToolbar';
import { useGetRegisterTableProps } from './config';

type GetPolicyAttestationRecordsData = NonNullable<
  ReturnType<typeof useGetAttestationsRegister>['data']
>;

export interface ByUserViewProps {
  attestationsRegisterData: GetPolicyAttestationRecordsData | undefined;
  loading: boolean;
  viewSelector: React.ReactNode;
  title: string;
  subTitle?: string;
}

const View: React.FC<ByUserViewProps> = ({
  attestationsRegisterData,
  loading,
  viewSelector,
  title,
  subTitle,
}) => {
  const objectToolbarEnabled = useIsFeatureFlagEnabled('dynamic_forms');
  const tableProps = useGetRegisterTableProps(
    attestationsRegisterData?.attestation_record
  );
  const counter = getCounter(tableProps.totalItemsCount, loading);

  const header = (
    <div className={'flex justify-between'}>
      <TabHeader>{subTitle}</TabHeader>
      {viewSelector}
    </div>
  );

  return (
    <PageLayout
      helpTranslationKey={'policy.registerHelp'}
      title={title}
      counter={counter}
      // Object-level toolbar (CUS-176) — flag-gated. This view has no ribbon, so
      // no `getActiveRibbonFilters` is passed. Legacy ExportButton kept as the
      // flag-off fallback.
      headerOverride={
        objectToolbarEnabled ? (
          <AttestationRegisterToolbar
            title={title}
            counter={counter}
            tableProps={tableProps}
          />
        ) : undefined
      }
      actions={<ExportButton tableProps={tableProps} entityLabel={title} />}
    >
      <Table {...tableProps} loading={loading} header={header} />
    </PageLayout>
  );
};

export default View;
